/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyCounselingSlotQuota,
  PharmacyCounselingSlotQuotaFromJSON,
  PharmacyCounselingSlotQuotaFromJSONTyped,
  PharmacyCounselingSlotQuotaToJSON,
} from "./";

export const GetPharmacyCounselingSlotQuotasResponseTypename = "GetPharmacyCounselingSlotQuotasResponse" as const;

/**
 *
 * @export
 * @interface GetPharmacyCounselingSlotQuotasResponse
 */
export interface GetPharmacyCounselingSlotQuotasResponse {
  /**
   *
   * @type {Array<PharmacyCounselingSlotQuota>}
   * @memberof GetPharmacyCounselingSlotQuotasResponse
   */
  counselingSlotQuotas?: Array<PharmacyCounselingSlotQuota>;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetPharmacyCounselingSlotQuotasResponse
   */
  readonly __typename?: string;
}

export function GetPharmacyCounselingSlotQuotasResponseFromJSON(json: any): GetPharmacyCounselingSlotQuotasResponse {
  return GetPharmacyCounselingSlotQuotasResponseFromJSONTyped(json, false);
}

export function GetPharmacyCounselingSlotQuotasResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPharmacyCounselingSlotQuotasResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetPharmacyCounselingSlotQuotasResponseTypename,

    counselingSlotQuotas: !exists(json, "counseling_slot_quotas")
      ? undefined
      : (json["counseling_slot_quotas"] as Array<any>).map(PharmacyCounselingSlotQuotaFromJSON),
  };
}

export function GetPharmacyCounselingSlotQuotasResponseToJSON(
  object?: GetPharmacyCounselingSlotQuotasResponse | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    counseling_slot_quotas:
      value.counselingSlotQuotas === undefined
        ? undefined
        : (value.counselingSlotQuotas as Array<any>).map(PharmacyCounselingSlotQuotaToJSON),
  };
}
